import { render, staticRenderFns } from "./CreateChannelModal.vue?vue&type=template&id=873f8748&"
import script from "./CreateChannelModal.vue?vue&type=script&lang=js&"
export * from "./CreateChannelModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateChannelModal.vue?vue&type=style&index=0&id=873f8748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports